import { Button } from '@abyss/web/ui/Button';
import { Text } from '@abyss/web/ui/Text';
import { LineOfBusiness } from 'api/src/services/Constants';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CountyStateSelectInput } from '../../../common/CountyStateSelectInput';
import { LocationLabel } from '../../../common/PSXHeader/LocationInput/LocationInput.styled';
import { LocationInputContainer } from './GuestLocation.style';
import { GuestLocation } from './GuestLocation.utils';
import { GuestLocationInput, PostalLocationData } from './GuestLocationInput';

export type GuestLocationSearchProps = {
  isLocationModal?: boolean;
  isDataLoaded: boolean;
  isCountyDropdownLoading?: boolean;
  lob?: string;
  location?: GuestLocation;
  setLocation: (a: GuestLocation) => void;
  currentInputValue?: string;
  setCurrentInputValue?: (value: string) => void;
  selectedCounty?: string;
  setSelectedCounty: (value: string) => void;
  showCountyDropdown?: boolean;
  setShowCountyDropdown: (value: boolean) => void;
  usPostalPointId?: string;
  onSubmit?: () => void;
  onPostalLocationSelected?: (data: PostalLocationData) => void;
};

export const GuestLocationSearch = ({
  isLocationModal,
  isDataLoaded,
  isCountyDropdownLoading = false,
  lob = '',
  location,
  setLocation,
  setCurrentInputValue = () => {},
  selectedCounty = '',
  setSelectedCounty,
  showCountyDropdown = false,
  usPostalPointId = '',
  onSubmit,
  onPostalLocationSelected,
}: GuestLocationSearchProps) => {
  const { t } = useTranslation();
  const displaySelectButton = !isLocationModal;
  const [isOnFocus, setIsOnFocus] = useState(false);
  const isLocationModalInFocus = isOnFocus && isLocationModal;

  const isButtonDisabled =
    !location?.label ||
    !isDataLoaded ||
    (showCountyDropdown && selectedCounty === '');

  return (
    <React.Fragment>
      <LocationInputContainer
        id="location-input-container"
        isLocationModal={isLocationModal}
        isLocationModalInFocus={isLocationModalInFocus}
      >
        <div id="location-search-input-area">
          <Text css={LocationLabel}>{'Location'}</Text>
          <GuestLocationInput
            isLocationModal={isLocationModal}
            location={location}
            onPostalLocationSelected={onPostalLocationSelected}
            setCurrentInputValue={setCurrentInputValue}
            setIsOnFocus={setIsOnFocus}
            setLocation={setLocation}
          />
        </div>
        {displaySelectButton && (
          <div style={{ alignSelf: 'center' }}>
            <Button
              data-auto-testid="submit-button"
              data-testid="submit-button"
              disabled={isButtonDisabled}
              onClick={onSubmit}
              size="$md"
              type="submit"
            >
              {t('COMPARE_BUTTONS.SELECT')}
            </Button>
          </div>
        )}
      </LocationInputContainer>
      {showCountyDropdown && (
        <div style={{ marginTop: '16px' }}>
          <Text css={{ marginBottom: '8px' }}>
            {lob === LineOfBusiness.MR
              ? t('GUEST_COUNTY_STATE_MODAL.EDIT_SEARCH_COUNTY')
              : t('GUEST_COUNTY_STATE_MODAL.EDIT_SEARCH_STATE')}
          </Text>
          <div style={{ marginBottom: '8px' }}>
            <CountyStateSelectInput
              isCountyList={lob === LineOfBusiness.MR}
              onChange={(value: string | number | Function) =>
                setSelectedCounty(String(value))
              }
              placeholder={t('GUEST_COUNTY_STATE_MODAL.SELECT') as string}
              selectedValue={selectedCounty}
              show={!isCountyDropdownLoading}
              usPostalPointId={usPostalPointId}
              width={300}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
